import * as React from 'react'
const UCen = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 84.08 84.08" {...props}>
    <defs>
      <style>
        {
          '.logo-ucen_svg__uuid-89cf78fb-c09d-466c-957a-9028ecea3ccb{stroke-width:0}'
        }
      </style>
    </defs>
    <g
      id="logo-ucen_svg__uuid-99930280-34b9-4939-b3e2-d557442f443a"
      data-name="Layer 1">
      <path
        d="M55.93 51.34H37.09V26.6h18.66v4.84H42.49v5.02h11.67v4.84H42.49v5.2h13.43v4.84Zm.53 27.82V51.93h5.52l12.66 16.64s.07-.08.1-.12V51.93h5.91v6.73c2.2-5.1 3.42-10.72 3.42-16.62C84.08 18.82 65.26 0 42.04 0 29.33 0 17.93 5.64 10.22 14.56v6.11c0 4.47 2.24 6.79 5.92 6.79s5.93-2.24 5.93-6.59V5.14h6.04v15.5c0 8.32-4.67 12.4-12.05 12.4-6.55 0-10.84-3.25-11.72-9.64A42.063 42.063 0 0 0 0 42.04c0 5.19.94 10.15 2.66 14.74-.2-.93-.3-1.89-.3-2.88 0-7.7 6.26-13.97 13.97-13.97 4.39 0 8.51 1.9 11.21 5.45l-4.38 3.25a8.623 8.623 0 0 0-6.83-3.36c-4.76 0-8.64 3.87-8.64 8.64s3.88 8.64 8.64 8.64c2.85 0 5.38-1.39 6.96-3.52l4.51 3.33c-2.92 3.68-7.09 5.53-11.46 5.53s-8.52-2.15-11.07-5.47C12.44 75.35 26.23 84.1 42.06 84.1c7.14 0 13.85-1.78 19.74-4.92h-5.32Z"
        className="logo-ucen_svg__uuid-89cf78fb-c09d-466c-957a-9028ecea3ccb"
      />
      <path
        d="m70.71 72.79-8.33-10.94v16.99c3.02-1.67 5.82-3.71 8.33-6.05"
        className="logo-ucen_svg__uuid-89cf78fb-c09d-466c-957a-9028ecea3ccb"
      />
    </g>
  </svg>
)
export default UCen
